import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Spinner } from '@storaensods/se-design-system';

import icons from './../../icons.svg';
import RefillPlanDataView from './refillPlanDataView';

const Loading = styled(Spinner)`
  margin-top: 3rem;
  display: inline-block;
`;

const ReplenishPlan = ({
  replenishPlan,
  replenishRule,
  cabinetItems,
  currentItemsLoading,
  fetchCabinetItems,
  deviceCode,
  t,
}) => {
  const [tableHeaderTop, setTableHeaderTop] = useState(undefined);

  useEffect(() => {
    const headerEl = document.querySelector('#replenish-plan__table-header');
    if (headerEl) {
      setTableHeaderTop(headerEl.getBoundingClientRect().top);
    } else {
      setTableHeaderTop(undefined);
    }
  }, []);

  useEffect(() => {
    if (!tableHeaderTop) return;

    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableHeaderTop]);

  const isSticky = e => {
    const headerEl = document.querySelector('#replenish-plan__table-header');
    const placeholderEl = document.querySelector(
      '#replenish-plan__table-header-space-placeholder'
    );
    const scrollTop = window.scrollY;
    if (scrollTop >= tableHeaderTop) {
      placeholderEl.classList.add(
        'replenish-plan__table-header-space-placeholder-active'
      );
      headerEl.classList.add(
        'replenish-plan__table-container-header-is-sticky'
      );
    } else {
      headerEl.classList.remove(
        'replenish-plan__table-container-header-is-sticky'
      );
      placeholderEl.classList.remove(
        'replenish-plan__table-header-space-placeholder-active'
      );
    }
  };

  /**
   * if replenish plan is still loading, show loader
   */
  if (replenishPlan.fetching) {
    return <Loading />;
  }

  /**
   * if there is an error, show the error message
   */
  if (replenishPlan.error) {
    return (
      <section className="replenishment">
        <div className="replenishment__popup">
          <div className="replenishment__popup-text">
            <svg>
              <use xlinkHref={`${icons}#icon-warning`} />
            </svg>
            <span className="replenishment__popup-text-negative">
              {t(replenishPlan.error)}
            </span>
          </div>
        </div>
      </section>
    );
  }

  /**
   * if no refill plan, show the message
   */
  if (replenishPlan.plan && replenishPlan.plan.length === 0) {
    return (
      <div className="replenishment__popup">
        <span className="replenishment__popup-text-neutral">
          {t('common:no_plan')}
        </span>
      </div>
    );
  }

  return (
    <section className="replenish-plan">
      <RefillPlanDataView
        replenishPlan={replenishPlan}
        replenishRule={replenishRule}
        cabinetItems={cabinetItems}
        currentItemsLoading={currentItemsLoading}
        fetchCabinetItems={fetchCabinetItems}
        deviceCode={deviceCode}
        t={t}
      />
    </section>
  );
};

export default ReplenishPlan;
